import { MaxAssetCountPerBulkAction } from '../constants';
import type { BulkActions } from '../types';

type CheckCanPerformBulkActionProps = {
  action: BulkActions;
  assetCount: number;
};

export const checkCanPerformBulkAction = ({
  assetCount,
  action,
}: CheckCanPerformBulkActionProps) => {
  /**
   * @todo (WORK-2691): Finalize action limits
   */
  const maxAssetCount = MaxAssetCountPerBulkAction[action];
  return assetCount <= maxAssetCount;
};
